import app from '../app.first';

app.RegistrationForm = class extends app.Component {
    onReady($this) {
        if ($this.data('trustedClient')) {
            return true;
        }

        let allowSubmit = false;
        $this.on('submit', () => {
            if (allowSubmit) {
                return true;
            }
            return false;
        });

        $this.on('formvalid.zf.abide', function() {
            grecaptcha.ready(() => {
                grecaptcha.execute('6Ldrh4gUAAAAAFo9_t2rmN59KWOEBQ14S5-lyOin', {action: 'action_name'})
                .then(token => {
                    $.ajax({
                        url: "/captcha/verify",
                        data: {
                            response: token
                        },
                        method: 'POST',
                        beforeSend: xhr => {
                            xhr.setRequestHeader('X-CSRF-Token', $('[name="_csrfToken"]').val());
                        },
                        success: response => {
                            if (response.success && response.score > response.tolerance) {
                                allowSubmit = true;
                                //This is a workaround to force to work on live
                                $this.off('submit').trigger('submit');
                            }
                        }
                    });
                });
            });
        });
    }
}